<template>
  <el-dialog v-model="dlgVisible"
    title="默认交易场所是备案地区所在的交易中心，如特殊情况请重新选择。"
    custom-class="dlg-bear-trade-center"
    top="30px"
    width="950px"
    @close="fnClose"
    :close-on-click-modal="false"
  >
    <el-radio-group v-model="value" class="dbtc__container">
      <div class="dbtc__widget" v-for="(obj, i) in radios" :key="i">
        <div class="dbtc__line province">
          <template v-if="obj.province.length">
            <el-radio v-for="(o, j) in obj.province" :key="j" :label="o.Name" class="dbtc__radio">{{o.Name}}</el-radio>
          </template>
          <el-radio v-else label="其他" disabled>其他</el-radio>
        </div>
        <div class="dbtc__line city">
          <el-radio v-for="(o, j) in obj.city" :key="j" :label="o.Name" class="dbtc__radio">{{o.Name}}</el-radio>
        </div>
        <div class="dbtc__line other">
          <el-radio v-for="(o, j) in obj.other" :key="j" :label="o.Name" class="dbtc__radio">{{o.Name}}</el-radio>
        </div>
      </div>
    </el-radio-group>
    <template #footer>
      <el-button type="default" @click="fnClose">取消</el-button>
      <el-button type="primary" @click="fnConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'BearTradeCenter',
  data() {
    return {
      dlgVisible: false,
      radios: [],
      key: '',
      value: ''
    }
  },
  emits: ['change'],
  computed: {
    ...mapState(['form'])
  },
  created() {
  },
  mounted() {
    this['houseStore/setComps']({key: 'bearTradeCenter', $vm: this})
  },
  methods: {
    init({key}) {
      if(this.form.regionId.indexOf('x') === -1) {
        this['houseStore/getTradeCenterRadios']().then(({radios, regions}) => {
          this.radios = radios
          this.regions = regions
          this.key = key
          this.value = this.form[key]
          this.dlgVisible = true          
        })
      }
    },
    fnClose() {
      this.dlgVisible = false
      this.key = ''
      this.value = ''
    },
    fnConfirm() {
      if(!this.value) return this.$message.info('请选择交易中心')
      if(this.form[this.key] !== this.value) {
        this.form[this.key] = this.value
        this.$emit('change', {
          value: this.value,
          radios: this.radios,
          regions: this.regions
        })
      }
      this.fnClose()
    },
    ...mapMutations(['houseStore/setComps']),
    ...mapActions(['houseStore/getTradeCenterRadios'])
  }
}
</script>
<style lang="scss">
.dlg-bear-trade-center{
  .dbtc {
    &__container {
      max-height: 700px;
      overflow: auto;
    }
    &__widget {
      margin: 10px 0;
      width: 100%;
    }
    &__line {
      padding: 0 5px;
      &.province {
        position: sticky;
        top: 0;
        z-index: 1;
        background: whitesmoke;
      }
    }
    &__radio {
      min-width: 100px;
      margin-right: 10px;
    }
  }
}  
</style>